import React, { useState, useEffect, Fragment } from 'react'
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import store from 'store/store';
import Menu from './Menu'
import * as IconsBi from "react-icons/bi";
import logoIcon from 'assets/images/logo-icon.png'
import { Status, threePoint, dictionary } from 'components/common/Config'

import { Sidebar as NewSidebar, Menu as NewMenu, MenuItem, SubMenu } from 'react-pro-sidebar';

import * as IconsBs from "react-icons/bs";
import * as IconsFa from "react-icons/fa6";
import * as IconsGr from "react-icons/gr";
import * as IconsIm from "react-icons/im";
import * as IconsTb from "react-icons/tb";
import * as IconsSi from "react-icons/si";
import * as IconsRi from "react-icons/ri";


function SidebarV2(props) {
    const state = store.getState()

	// let navigate = useNavigate();
	let location = useLocation();
	
	const [color, setColor] = useState("#ffffff");
	const [menus,setMenus] = useState([])
    const [prefix,setPrefix] = useState([])
	const [open, setOpen] = useState(undefined)

    useEffect(() => {
        let user = state?.user
        if(user?.type) {
            let menus_h = [general_menuItems_top]
            let color_h = ['']
            let prefix_h = ['']

            // [general_menuItems_top,admin_menuItems,operator_menuItems,user_menuItems,general_menuItems_bottom]
            if(user?.type?.includes('admin')) {
                menus_h.push(admin_menuItems)
                color_h.push('#6610f2')
                prefix_h.push('/a')
            }
            if(user?.type?.includes('operator')) {
                menus_h.push(operator_menuItems)
                color_h.push('green')
                prefix_h.push('/o')
            }
            if(user?.type?.includes('user')) {
                menus_h.push(user_menuItems)
                color_h.push('#5f5f5f')
                prefix_h.push('/u')
            }
            
            menus_h.push(general_menuItems_bottom)
            color_h.push('')
            prefix_h.push('')

            setColor(color_h)
            setPrefix(prefix_h)
            setMenus(menus_h)
        }
    },[state?.user])

    useEffect(() => {
        setOpen(location.state?.parent)
    }, [location.state?.parent])

    const handleOpenSubMenu = (key) => {
        if (open === key) {
            setOpen(undefined);
        } else {
            setOpen(key);
        }
    };

    const admin_menuItems = [
        {
            id: 'admin-departments',
            title: 'مدیریت واحدهای سازمانی',
            icon: <IconsIm.ImTree size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'admin-departments-new',
                    title: 'ثبت واحد جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/departments/new',
                    visibility: false,
                },
                {
                    id: 'admin-departments-list',
                    title: 'فهرست واحدها',
                    icon: <IconsBi.BiCircle />,
                    url: '/departments/list',
                    visibility: true,
                },
            ]
        },
        {
            id: 'admin-users',
            title: 'مدیریت کاربران و مشتریان',
            icon: <IconsBi.BiGroup size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'admin-users-new',
                    title: 'ثبت کاربر سازمانی جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/users/new',
                    visibility: true,
                },
                {
                    id: 'admin-users-list',
                    title: 'فهرست کاربران سازمانی',
                    icon: <IconsBi.BiCircle />,
                    url: '/users/list',
                    visibility: true,
                },
                {
                    id: 'admin-customers-new',
                    title: 'ثبت مشتری جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/customers/new',
                    visibility: true,
                },
                {
                    id: 'admin-customers-list',
                    title: 'فهرست مشتریان',
                    icon: <IconsBi.BiCircle />,
                    url: '/customers/list',
                    visibility: true,
                },
            ]
        },
        {
            id: 'admin-groups',
            title: 'مدیریت گروه های کاری',
            icon: <IconsGr.GrGroup size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'admin-groups-new',
                    title: 'ایجاد گروه جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/groups/new',
                    visibility: true,
                },
                {
                    id: 'admin-groups-list',
                    title: 'فهرست گروه های کاری',
                    icon: <IconsBi.BiCircle />,
                    url: '/groups/list',
                    visibility: true,
                },
            ]
        },
        
        //////////// Professional Ver.
        // {
        //     id: 'admin-categories',
        //     title: 'مدیریت دسته بندی ها',
        //     icon: <IconsBi.BiCategoryAlt />,
        //     url: '#',
        //     visibility: true,
        //     children: [
        //         {
        //             id: 'admin-categories-new',
        //             title: 'ایجاد دسته جدید',
        //             icon: <IconsBi.BiCircle />,
        //             url: '/categories/new',
        //             visibility: true,
        //         },
        //         {
        //             id: 'admin-categories-list',
        //             title: 'فهرست دسته ها',
        //             icon: <IconsBi.BiCircle />,
        //             url: '/categories/list',
        //             visibility: true,
        //         },
        //     ]
        // },

        //////////// Simple Ver.
        {
            id: 'admin-categories1',
            title: 'مدیریت ساختار و سنجه ها',
            icon: <IconsBi.BiCategoryAlt size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'admin-categories1-new',
                    title: 'ایجاد حوزه جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/categories/new',
                    visibility: true,
                },
                {
                    id: 'admin-categories1-list',
                    title: 'فهرست حوزه ها',
                    icon: <IconsBi.BiCircle />,
                    url: '/categories/list',
                    visibility: true,
                },
                {
                    id: 'admin-categories1-tree',
                    title: 'نمایش درختی',
                    icon: <IconsBi.BiCircle />,
                    url: '/categories/tree',
                    visibility: true,
                },
                {
                    id: 'admin-categories1-search',
                    title: 'جستجو در ساختار',
                    icon: <IconsBi.BiCircle />,
                    url: '/categories/search',
                    visibility: true,
                },
                {
                    id: 'admin-categories1-import-history',
                    title: 'سوابق ایمپورت نتایج داوری',
                    icon: <IconsBi.BiCircle />,
                    url: '/categories/import-history/list',
                    visibility: true,
                },
            ]
        },
        // {
        //     id: 'admin-questions',
        //     title: 'مدیریت سنجه ها',
        //     icon: <IconsFa.FaClipboardQuestion />,
        //     url: '#',
        //     visibility: true,
        //     children: [
        //         {
        //             id: 'admin-questions-new',
        //             title: 'ایجاد سنجه جدید',
        //             icon: <IconsBi.BiCircle />,
        //             url: '/questions/new',
        //             visibility: true,
        //         },
        //         {
        //             id: 'admin-questions-list',
        //             title: 'فهرست سنجه ها',
        //             icon: <IconsBi.BiCircle />,
        //             url: '/questions/list',
        //             visibility: true,
        //         },
        //     ]
        // },
        {
            id: 'admin-answers',
            title: 'دسته بندی پاسخها',
            icon: <IconsBs.BsCheck2Square size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'admin-answers-new',
                    title: 'ایجاد دسته جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/answer-categories/new',
                    visibility: true,
                },
                {
                    id: 'admin-answers-list',
                    title: 'فهرست دسته های پاسخها',
                    icon: <IconsBi.BiCircle />,
                    url: '/answer-categories/list',
                    visibility: true,
                },
            ]
        },
        {
            id: 'admin-media',
            title: 'مدیریت شرکتها',
            icon: <IconsTb.TbWorldWww size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'admin-media-new',
                    title: 'ثبت شرکت جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/new',
                    visibility: true,
                },
                {
                    id: 'admin-media-list',
                    title: 'فهرست شرکتها',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/list',
                    visibility: true,
                },
                {
                    id: 'admin-media-search',
                    title: 'جستجوی شرکتها',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/search',
                    visibility: true,
                },
                {
                    id: 'admin-media-new-group',
                    title: 'ایجاد گروه شرکت جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/groups/new',
                    visibility: true,
                },
                {
                    id: 'admin-media-group-list',
                    title: 'فهرست گروه های شرکت',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/groups/list',
                    visibility: true,
                },
                {
                    id: 'admin-media-tags-group',
                    title: 'ایجاد تگ جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/tags/new',
                    visibility: true,
                },
                {
                    id: 'admin-media-tags-list',
                    title: 'فهرست تگها',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/tags/list',
                    visibility: true,
                },
            ]
        },
    ]

    const operator_menuItems = [
        {
            id: 'operator-groups',
            title: 'گروه های کاری',
            icon: <IconsGr.GrGroup size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'operator-groups-list',
                    title: 'فهرست گروه های کاری',
                    icon: <IconsBi.BiCircle />,
                    url: '/groups/list',
                    visibility: true,
                },
            ]
        },
        {
            id: 'operator-categories',
            title: 'نظام ارزیابی',
            icon: <IconsBi.BiCategoryAlt size="24" />,
            url: '#',
            visibility: true,
            children: [
                // {
                //     id: 'operator-categories-list',
                //     title: 'فهرست دسته ها',
                //     icon: <IconsBi.BiCircle />,
                //     url: '/categories/list',
                //     visibility: true,
                // },
                {
                    id: 'operator-categories-tree',
                    title: 'نمایش درختی',
                    icon: <IconsBi.BiCircle />,
                    url: '/categories/tree',
                    visibility: true,
                },
            ]
        },
        {
            id: 'operator-assessments',
            title: 'ارزیابی ها',
            icon: <IconsFa.FaListCheck size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'operator-assessments-new',
                    title: 'ایجاد ارزیابی جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/assessments/new',
                    visibility: true,
                },
                {
                    id: 'operator-assessments-current',
                    title: 'فهرست ارزیابی های جاری',
                    icon: <IconsBi.BiCircle />,
                    url: '/assessments/current',
                    visibility: true,
                },
                {
                    id: 'operator-assessments-archive',
                    title: 'فهرست ارزیابی های پیشین',
                    icon: <IconsBi.BiCircle />,
                    url: '/assessments/archive',
                    visibility: true,
                },
                {
                    id: 'operator-assessments-search',
                    title: 'جستجوی نتایج',
                    icon: <IconsBi.BiCircle />,
                    url: '/assessments/search',
                    visibility: true,
                },
            ]
        },

        {
            id: 'operator-scoring-pattern',
            // title: 'الگوهای ارزیابی',
            title: 'الگوهای رتبه‌بندی',
            icon: <IconsRi.RiEqualizerFill size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'operator-scoring-pattern-new',
                    title: 'ایجاد الگوی جدید',
                    icon: <IconsBi.BiCircle />,
                    url: '/scoring-patterns/new',
                    visibility: true,
                },
                {
                    id: 'operator-scoring-pattern-list',
                    title: 'فهرست الگوها',
                    icon: <IconsBi.BiCircle />,
                    url: '/scoring-patterns/list',
                    visibility: true,
                },
                {
                    id: 'operator-scoring-pattern-formulas',
                    title: 'فرمولهای اختصاصی',
                    icon: <IconsBi.BiCircle />,
                    url: '/scoring-patterns/formulas',
                    visibility: true,
                },
            ]
        },
        {
            id: 'operator-media',
            title: 'شرکتها',
            icon: <IconsTb.TbWorldWww size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'operator-media-list',
                    title: 'فهرست شرکتها',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/list',
                    visibility: true,
                },
                {
                    id: 'operator-media-search',
                    title: 'جستجوی شرکتها',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/search',
                    visibility: true,
                },
                {
                    id: 'operator-media-group-list',
                    title: 'فهرست گروه های شرکت',
                    icon: <IconsBi.BiCircle />,
                    url: '/media/groups/list',
                    visibility: true,
                },
            ]
        },

        {
            id: 'operator-reports',
            title: 'گزارش‌ها',
            icon: <IconsFa.FaRegChartBar size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'operator-reports-last-result',
                    title: 'آخرین نتیجه سنجه',
                    icon: <IconsBi.BiCircle />,
                    url: '/reports/last-result',
                    visibility: true,
                },
            ]
        },
    ]

    const user_menuItems = [
        {
            id: 'user-categories',
            title: 'نظام ارزیابی',
            icon: <IconsBi.BiCategoryAlt size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'operator-categories-tree',
                    title: 'نمایش درختی',
                    icon: <IconsBi.BiCircle />,
                    url: '/categories/tree',
                    visibility: true,
                },
            ]
        },
        {
            id: 'user-assessments',
            title: 'ارزیابی ها',
            icon: <IconsFa.FaListCheck size="24" />,
            url: '#',
            visibility: true,
            children: [
                {
                    id: 'user-assessments-current',
                    title: 'فهرست ارزیابی های جاری',
                    icon: <IconsBi.BiCircle />,
                    url: '/assessments/current',
                    visibility: true,
                },
                {
                    id: 'user-assessments-archive',
                    title: 'فهرست ارزیابی های پیشین',
                    icon: <IconsBi.BiCircle />,
                    url: '/assessments/archive',
                    visibility: true,
                },
                {
                    id: 'user-assessments-search',
                    title: 'جستجوی نتایج',
                    icon: <IconsBi.BiCircle />,
                    url: '/assessments/search',
                    visibility: true,
                },
            ]
        },
    ]

    const general_menuItems_top = [
        {
            id: 'dashboard',
            title: 'داشبورد',
            icon: <IconsBi.BiSlideshow size="24" />,
            url: '/dashboard',
            visibility: true,
            children: '',
        },
    ]

    const general_menuItems_bottom = [
        {
            id: 'logout',
            title: 'خروج',
            icon: <IconsBi.BiExit size="24" />,
            url: '/logout',
            visibility: true,
        },
    ]

    return (
        <NewSidebar
            rtl
            rootStyles={{
                position: "sticky",
                top:'60px',
                height: "calc(100vh - 60px)",
            }}
            toggled={props?.toggled}
            collapsed={props?.collapsed}
            collapsedWidth="60px"
            style={{marginTop:'60px'}}
        >
			<div className="sidebar-header">
				<div>
					<img src={logoIcon} className="logo-icon" alt="logo icon" />
				</div>
				<div>
					{
						dictionary['base-'+dictionary.app].sidebarName?.length > 14
						?
						<h5 className="logo-text" style={{fontSize:'13px'}}>{dictionary['base-'+dictionary.app].sidebarName}</h5>
						:
						<h4 className="logo-text">{dictionary['base-'+dictionary.app].sidebarName}</h4>
					}
				</div>
			</div>
			<NewMenu>
				{
					menus?.length > 0 &&
						<Fragment>
						{
							menus?.map((menu,menu_index) => {
								return (
										<Fragment key={menu_index}>
											{
												menu.filter(mi => mi.visibility).map(mi => (
													(mi.children?.length > 0 && mi.children?.filter(child=>child.visibility).length > 0)
													?
														<SubMenu
															key={mi.id}
															icon={mi.icon}
															label={mi.title}
															rootStyles={{color:color[menu_index]}}
															open={open === mi.id}
															onClick={() => handleOpenSubMenu(mi.id)}
														>
															{
																mi.children.filter(child => child.visibility).map(child => {
																	return (
																		<MenuItem 
																			active={(location.pathname === prefix[menu_index] + child.url) ? true : false}
																			key={child.id}
																			icon={child.icon}
																			component={<Link to={prefix[menu_index] + child.url} state={{parent:mi.id}} className="link" />}
																			style={{color:color[menu_index]}}
																		>
																			{child.title}
																		</MenuItem>
																	)
																})
															}
														</SubMenu>
													:
														<MenuItem 
															active={(location.pathname === prefix[menu_index] + mi.url) ? true : false}
															key={mi.id}
															icon={mi.icon}
															component={<Link to={prefix[menu_index] + mi.url} className="link" />}
															rootStyles={{color:color[menu_index]}}
														>
															{mi.title}
														</MenuItem>
												))
											}
										</Fragment>
									)
								})
							}   
						</Fragment>
				}
			</NewMenu>
		</NewSidebar>
    )
}

export default SidebarV2;